import React, { useState } from 'react';
import styled from 'styled-components';

const IAOfficersEdit = ({ darkMode, data, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    surname: data?.surname || data?.last_name || '',
    firstname: data?.firstname || data?.first_name || '',
    mothers_maiden_name: data?.mothers_maiden_name || data?.middle_name || '',
    sex: data?.sex || '',
    civil_status: data?.civil_status || '',
    name_of_spouse: data?.name_of_spouse || '',
    date_of_birth: data?.date_of_birth || '',
    tin: data?.tin || '',
    position: data?.position || '',
    educational_attainment: data?.educational_attainment || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmit === 'function') {
      onSubmit({ ...formData, id: data?.id });
    } else {
      console.log('IA Officer updated:', formData);
    }
    onClose();
  };

  return (
    <FormContainer darkMode={darkMode}>
      <FormHeader>
        <FormTitle>Edit IA Officer</FormTitle>
        <CloseButton onClick={onClose}>Ã—</CloseButton>
      </FormHeader>
      <Form onClick={(e) => e.stopPropagation()}>
        <InputGroup>
          <Label>Surname</Label>
          <Input type="text" name="surname" value={formData.surname} onChange={handleChange} required />
        </InputGroup>
        <InputGroup>
          <Label>First Name</Label>
          <Input type="text" name="firstname" value={formData.firstname} onChange={handleChange} required />
        </InputGroup>
        <InputGroup>
          <Label>Mother's Maiden Name</Label>
          <Input type="text" name="mothers_maiden_name" value={formData.mothers_maiden_name} onChange={handleChange} />
        </InputGroup>
        <InputGroup>
          <Label>Sex</Label>
          <Select name="sex" value={formData.sex} onChange={handleChange}>
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </Select>
        </InputGroup>
        <InputGroup>
          <Label>Civil Status</Label>
          <Select name="civil_status" value={formData.civil_status} onChange={handleChange}>
            <option value="">Select</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Widowed">Widowed</option>
            <option value="Separated">Separated</option>
          </Select>
        </InputGroup>
        <InputGroup>
          <Label>Name of Spouse</Label>
          <Input type="text" name="name_of_spouse" value={formData.name_of_spouse} onChange={handleChange} />
        </InputGroup>
        <InputGroup>
          <Label>Date of Birth</Label>
          <Input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} />
        </InputGroup>
        <InputGroup>
          <Label>TIN</Label>
          <Input type="text" name="tin" value={formData.tin} onChange={handleChange} />
        </InputGroup>
        <InputGroup>
          <Label>Position</Label>
          <Input type="text" name="position" value={formData.position} onChange={handleChange} required />
        </InputGroup>
        <InputGroup>
          <Label>Educational Attainment</Label>
          <Input type="text" name="educational_attainment" value={formData.educational_attainment} onChange={handleChange} />
        </InputGroup>
        <SubmitButton type="submit" onClick={handleSubmit}>
          Update Officer
        </SubmitButton>
      </Form>
    </FormContainer>
  );
};

export default IAOfficersEdit;
const FormContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? '#2a2a2a' : '#ffffff')};
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  padding: 20px;
  z-index: 1000;
  overflow-y: auto;
`;

const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const FormTitle = styled.h3`
  font-size: 18px;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const PhotoUpload = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const PhotoPlaceholder = styled.div`
  width: 150px;
  height: 150px;
  border: 2px dashed ${({ darkMode }) => (darkMode ? '#ffffff' : '#cccccc')};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PlaceholderText = styled.span`
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#666666')};
  font-size: 14px;
`;

const UploadButton = styled.button`
  padding: 6px 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #388e3c;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 14px;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
  margin-bottom: 5px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: ${({ darkMode }) => (darkMode ? '#333333' : '#ffffff')};
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: ${({ darkMode }) => (darkMode ? '#333333' : '#ffffff')};
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const SubmitButton = styled.button`
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    background-color: #388e3c;
  }
`;
